import React from 'react'
// import NoData from 'components/NoData'
import Button from 'components/Button'
// import AddCard from 'components/AddCard'
import SelectPlan from 'components/SelectPlan'
// import {Elements} from 'react-stripe-elements';
import { Query } from 'react-apollo'
import { ME } from 'operations/User'
import Card from 'components/Card'
import moment from 'moment'
import Tabs from 'components/Tabs'
import './account.css'

export class Account extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            addPayment: false,
            selectPlan: false,
        }

        this.handleClose = this.handleClose.bind(this)
    }

    handleClose(e) {
        this.setState({
            addPayment: false,
            selectPlan: false
        })
    }

    render() {

        const cardIcons = {
            "Visa": "https://js.stripe.com/v3/fingerprinted/img/visa-d6c6e0a636f7373e06d5fb896ad49475.svg",
            "Visa (debit)": "https://js.stripe.com/v3/fingerprinted/img/visa-d6c6e0a636f7373e06d5fb896ad49475.svg",
            "MasterCard": "https://js.stripe.com/v3/fingerprinted/img/mastercard-a96ee3841a5e1e28d05ed3f0f4da62b8.svg",
            "MasterCard (2-series)": "https://js.stripe.com/v3/fingerprinted/img/mastercard-a96ee3841a5e1e28d05ed3f0f4da62b8.svg",
            "MasterCard (debit)": "https://js.stripe.com/v3/fingerprinted/img/mastercard-a96ee3841a5e1e28d05ed3f0f4da62b8.svg",
            "MasterCard (prepaid)": "https://js.stripe.com/v3/fingerprinted/img/mastercard-a96ee3841a5e1e28d05ed3f0f4da62b8.svg",
            "American Express": "https://js.stripe.com/v3/fingerprinted/img/amex-edf6011de255d8a4c22904795c9d8770.svg",
            "Discover": "https://js.stripe.com/v3/fingerprinted/img/discover-8f3d8fc6ef836da1fcac12c095ee6fb8.svg",
            "Diners Club": "https://js.stripe.com/v3/fingerprinted/img/diners-fced9e136fd8c25f40a3e7b37a51dc1d.svg",
            "JCB": "https://js.stripe.com/v3/fingerprinted/img/jcb-1b12d588a1e9465d4d9fb84a610f9136.svg",
            "UnionPay": "https://js.stripe.com/v3/fingerprinted/img/unionpay-en-099cb6671310a54f640ac16d5f2a825c.svg"
        }

        return (
            <div>
                <h1>Account</h1>

                <Tabs
                    tabs={[
                        'Billing',
                        'Security'
                    ]}
                >

                    <div>
                        
                        <Query query={ ME }>
                            {({ loading, error, data }) => {
                                
                                if (loading) return 'Loading...';
                                if (error) return `Error: ${error}`;

                                // if (error) return <NoData>Please add a payment method</NoData>
                                // if (!data.me.account || !data.me.account.paymentSources || !data.me.account.stripeCustomerId) {
                                //     return null
                                // }
                                
                                return (

                                    <React.Fragment>
                                        <h2>Subscription</h2>
                                        <div>
                                            <Card inline>
                                                <div className='subscription__container'>
                                                    <div>
                                                        <div className='subscription__heading'>Plan</div>
                                                        { data.me.account.plan ? data.me.account.plan.name : '14 Day Trial' }
                                                    </div>
                                                    <div>
                                                        <div className='subscription__heading'>Price</div>
                                                        { data.me.account.plan ? `$${ data.me.account.plan.amount.toString().substring(0, data.me.account.plan.amount.toString().length - 2)  + '.' + data.me.account.plan.amount.toString().slice(-2) + ' /' + data.me.account.plan.interval }` : 'Free' }
                                                    </div>
                                                    <div>
                                                        <div className='subscription__heading'>{ data.me.account.plan ? 'Renews' : 'Expires' }</div>
                                                        { data.me.account.plan ? moment.unix(data.me.account.plan.renews).format('MMMM D, YYYY') : moment(parseInt(data.me.account.trialEnd, 10)).format('MMMM D, YYYY') }
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <Button secondary onClick={ () => { this.setState({ selectPlan: true }) } } >Select a plan</Button>
                                        {
                                            this.state.selectPlan ? (
                                                <SelectPlan onClose={ this.handleClose } />
                                            ) : null
                                        }

                                        {
                                            data.me.account.paymentSources ? (
                                                <React.Fragment>

                                                    <h2>Payment methods</h2>
                                                    {
                                                        data.me.account.paymentSources.map(data => {
                                                            const source = JSON.parse(data)

                                                            return (
                                                                <Card key={source.id} inline>
                                                                    <div className='paymentMethod__container'>
                                                                        <div>
                                                                            <div className='paymentMethod__cardHolder'>{source.owner.name}</div>
                                                                            <div>xxxx xxxx xxxx {source.card.last4}</div>
                                                                            <div>Expires { moment(source.card.exp_year + '-' + source.card.exp_month).format('MM/YY') }</div>
                                                                        </div>
                                                                        <div>
                                                                            <img style={{ width: '24px' }} src={cardIcons[source.card.brand]} alt="Credit Card Icon"></img>
                                                                        </div>
                                                                    </div>
                                                                </Card>
                                                            )
                                                        })
                                                    }

                                                </React.Fragment>
                                            ) : null
                                        }
                                        
                                        {/* <Button onClick={ () => { this.setState({ addPayment: true }) } }>Add card</Button> */}
                                    </React.Fragment>
                                )
                            }}
                        </Query>
                        
                        {
                            // this.state.addPayment ? (
                            //     <Elements><AddCard onClose={ this.handleClose } /></Elements>
                            // ) : null
                        }
                    </div>
                </Tabs>
            </div>
        )
    }

}




// WEBPACK FOOTER //
// ./src/containers/Account/index.js